/**
 * True when the browser is likely iPad / iPadOS, including Safari “Request Desktop Website”
 * (Macintosh UA + touch). Used to hide CSV bulk upload in favor of Manual Input / Supabase.
 */
export function isIPadLike(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/iPad/i.test(ua)) return true;
  const platform = navigator.platform || "";
  if (platform === "MacIntel" && navigator.maxTouchPoints > 1) return true;
  return false;
}
